export default __webpack_public_path__ + "static/media/newletterImgBg.dd252ad5.png";